import portalApi from './portalApi';

const portalDocumentService = {
  getSharedDocuments: () => portalApi.get('/portal/documents'),
  downloadDocument: (documentId) =>
    portalApi.get(`/portal/documents/${documentId}/download`, { responseType: 'blob' }),
};

export default portalDocumentService;
